import { gql } from '@apollo/client';

export type AbaId = 'atletas' | 'torneios' | 'ligas' | 'seguindo';

export interface PesquisaAtletaItem {
    id: string;
    usuario: {
        id: string;
        nome: string;
        username: string;
        imagemUrl: string | null;
        bannerUrl: string | null;
    };
}

export interface PesquisaTorneioItem {
    id: string;
    nome: string;
    username: string | null;
    avatarUrl: string | null;
    bannerUrl: string | null;
    status: string | null;
    ativo: boolean | null;
}

export interface PesquisaLigaItem {
    id: string;
    nome: string;
    username: string | null;
    imagemUrl: string | null;
    bannerUrl: string | null;
}

export interface PesquisaConnection<T> {
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
    items: T[];
}

export interface BuscarAtletasData {
    searchAtletas: PesquisaConnection<PesquisaAtletaItem>;
}

export interface BuscarAtletasVars {
    termo: string;
    page: number;
    size: number;
}

export interface BuscarTorneiosData {
    searchTorneios: PesquisaConnection<PesquisaTorneioItem>;
}

export interface BuscarTorneiosVars {
    termo: string;
    page: number;
    size: number;
}

export interface BuscarLigasData {
    searchLigas: PesquisaConnection<PesquisaLigaItem>;
}

export interface BuscarLigasVars {
    termo: string;
    page: number;
    size: number;
}

export interface BuscarSeguindoData {
    searchSeguindo: PesquisaConnection<PesquisaAtletaItem>;
}

export interface BuscarSeguindoVars {
    termo: string;
    page: number;
    size: number;
}

export const BUSCAR_ATLETAS = gql`
    query BuscarAtletas($termo: String!, $page: Int!, $size: Int!) {
        searchAtletas(termo: $termo, page: $page, size: $size) {
            page
            size
            totalItems
            totalPages
            items {
                id
                usuario {
                    id
                    nome
                    username
                    imagemUrl
                    bannerUrl
                }
            }
        }
    }
`;

export const BUSCAR_TORNEIOS = gql`
    query BuscarTorneios($termo: String!, $page: Int!, $size: Int!) {
        searchTorneios(termo: $termo, page: $page, size: $size) {
            page
            size
            totalItems
            totalPages
            items {
                id
                nome
                username
                avatarUrl
                bannerUrl
                status
                ativo
            }
        }
    }
`;

export const BUSCAR_LIGAS = gql`
    query BuscarLigas($termo: String!, $page: Int!, $size: Int!) {
        searchLigas(termo: $termo, page: $page, size: $size) {
            page
            size
            totalItems
            totalPages
            items {
                id
                nome
                username
                imagemUrl
                bannerUrl
            }
        }
    }
`;

export const BUSCAR_SEGUINDO = gql`
    query BuscarSeguindo($termo: String!, $page: Int!, $size: Int!) {
        searchSeguindo(termo: $termo, page: $page, size: $size) {
            page
            size
            totalItems
            totalPages
            items {
                id
                usuario {
                    id
                    nome
                    username
                    imagemUrl
                    bannerUrl
                }
            }
        }
    }
`;
